import { useState } from "react";
import type { GroupByMode } from "./groupProducts";

// Inventory Overview's Group by choice, remembered in this browser for
// every market. A missing, unknown or unreadable value starts at "none".
const STORAGE_KEY = "inventory.byWarehouse.groupBy";
const MODES: readonly string[] = ["none", "product_group"] satisfies GroupByMode[];

function readStored(): GroupByMode {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw && MODES.includes(raw)) return raw as GroupByMode;
  } catch {
    // storage unavailable — start ungrouped
  }
  return "none";
}

export function useStoredGroupBy(): [GroupByMode, (mode: GroupByMode) => void] {
  const [groupBy, setGroupBy] = useState<GroupByMode>(readStored);
  const change = (mode: GroupByMode) => {
    setGroupBy(mode);
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch {
      // storage unavailable — the choice lasts until the page reloads
    }
  };
  return [groupBy, change];
}
